import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useCreateResourceCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	unit?: string | Ref<string> | (() => string), 
	expenseClassification?: any | Ref<any> | (() => any), 
	costPerUnit?: number | null | Ref<number | null> | (() => number | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _unit = isRef<string>(unit) ? unit : ref<string>((typeof unit === 'function') ? unit() : unit)
	const _expenseClassification = isRef<any>(expenseClassification) ? expenseClassification : ref<any>((typeof expenseClassification === 'function') ? expenseClassification() : expenseClassification)
	const _costPerUnit = isRef<number | null>(costPerUnit) ? costPerUnit : ref<number | null>((typeof costPerUnit === 'function') ? costPerUnit() : costPerUnit)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		unit: _unit,
		expenseClassification: _expenseClassification,
		costPerUnit: _costPerUnit,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof unit === 'function') { _unit.value = unit() }
			if (typeof expenseClassification === 'function') { _expenseClassification.value = expenseClassification() }
			if (typeof costPerUnit === 'function') { _costPerUnit.value = costPerUnit() }

			return new c.CreateResourceCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _unit.value, _expenseClassification.value, _costPerUnit.value)
		})
	}

	return {
		...result,
		authorizedCreateResourceCommandV1: result.authorized,
		createResourceCommandV1: result.command,
		completedCreateResourceCommandV1: result.completed,
		errorCreateResourceCommandV1: result.error,
		invokeCreateResourceCommandV1: result.invoke,
		invokingCreateResourceCommandV1: result.invoking,
		succeedCreateResourceCommandV1: result.succeed,
		validationErrorsCreateResourceCommandV1: result.validationErrors,
		onSucceedCreateResourceCommandV1: result.onSucceed,
	}
}

export function useDeleteResourceCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeleteResourceCommandV1(_workspaceId.value, _strategyId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeleteResourceCommandV1: result.authorized,
		deleteResourceCommandV1: result.command,
		completedDeleteResourceCommandV1: result.completed,
		errorDeleteResourceCommandV1: result.error,
		invokeDeleteResourceCommandV1: result.invoke,
		invokingDeleteResourceCommandV1: result.invoking,
		succeedDeleteResourceCommandV1: result.succeed,
		validationErrorsDeleteResourceCommandV1: result.validationErrors,
		onSucceedDeleteResourceCommandV1: result.onSucceed,
	}
}

export function useUpdateResourceCapacitiesCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	entries?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _entries = isRef<any>(entries) ? entries : ref<any>((typeof entries === 'function') ? entries() : entries)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		entries: _entries,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof entries === 'function') { _entries.value = entries() }

			return new c.UpdateResourceCapacitiesCommandV1(_workspaceId.value, _strategyId.value, _id.value, _entries.value)
		})
	}

	return {
		...result,
		authorizedUpdateResourceCapacitiesCommandV1: result.authorized,
		updateResourceCapacitiesCommandV1: result.command,
		completedUpdateResourceCapacitiesCommandV1: result.completed,
		errorUpdateResourceCapacitiesCommandV1: result.error,
		invokeUpdateResourceCapacitiesCommandV1: result.invoke,
		invokingUpdateResourceCapacitiesCommandV1: result.invoking,
		succeedUpdateResourceCapacitiesCommandV1: result.succeed,
		validationErrorsUpdateResourceCapacitiesCommandV1: result.validationErrors,
		onSucceedUpdateResourceCapacitiesCommandV1: result.onSucceed,
	}
}

export function useUpdateResourceCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	unit?: string | Ref<string> | (() => string), 
	expenseClassification?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _unit = isRef<string>(unit) ? unit : ref<string>((typeof unit === 'function') ? unit() : unit)
	const _expenseClassification = isRef<any>(expenseClassification) ? expenseClassification : ref<any>((typeof expenseClassification === 'function') ? expenseClassification() : expenseClassification)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		unit: _unit,
		expenseClassification: _expenseClassification,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof unit === 'function') { _unit.value = unit() }
			if (typeof expenseClassification === 'function') { _expenseClassification.value = expenseClassification() }

			return new c.UpdateResourceCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _unit.value, _expenseClassification.value)
		})
	}

	return {
		...result,
		authorizedUpdateResourceCommandV1: result.authorized,
		updateResourceCommandV1: result.command,
		completedUpdateResourceCommandV1: result.completed,
		errorUpdateResourceCommandV1: result.error,
		invokeUpdateResourceCommandV1: result.invoke,
		invokingUpdateResourceCommandV1: result.invoking,
		succeedUpdateResourceCommandV1: result.succeed,
		validationErrorsUpdateResourceCommandV1: result.validationErrors,
		onSucceedUpdateResourceCommandV1: result.onSucceed,
	}
}

